import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";
import { CDN_BASE_URL } from "../../../config";
import GalleryModal from "../GalleryModal";

const BlogsVideo = () => {
  const [videos, setVideos] = useState();
  const [loading, setLoading] = useState();
  const [show2, setshow2] = useState();
  const [src, setsrc] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", "/blog/file/video", {}, {}).then(({ data }) => {
      setVideos(data?.data);
    });
    setLoading(false);
  }

  function handleOpenModal(srcc) {
    setshow2(true);
    setsrc(srcc);
  }

  if (loading) {
    return (
      <div className="flex justify-center">
        <Loading />
      </div>
    );
  }
  return videos?.map((video) => (
    <>
      {show2 && (
        <GalleryModal open={show2} handleClose={() => setshow2(false)}>
          <video controls className="w-full" src={src} alt="ModalImage" />
        </GalleryModal>
      )}
      <video
        onClick={(e) => handleOpenModal(e.currentTarget.src)}
        src={CDN_BASE_URL + video.file}
        className="w-full rounded-[8px] h-[44vw] col-span-3 object-cover"
      />
    </>
  ));
};

export default BlogsVideo;
